import MenuItem from '@mui/material/MenuItem';
import { isMobile } from 'react-device-detect';
import { FieldPath, FieldValues } from 'react-hook-form';

import { OptionWithIcon } from 'library/models/Option';

import {
	ControlledTextField,
	TextFieldElementProps,
} from './ControlledTextField';
import { SelectIconLabel } from './SelectIconLabel';
import { SelectLabel } from './SelectLabel';

export interface ControlledSelectProps<
	TFieldValues extends FieldValues = FieldValues,
	TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> extends TextFieldElementProps<TFieldValues, TName> {
	options: OptionWithIcon[];
	isSelectedIconOnly?: boolean;
}

export const ControlledSelect = <
	TFieldValues extends FieldValues = FieldValues,
	TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
	children,
	options,
	isSelectedIconOnly = false,
	...rest
}: ControlledSelectProps<TFieldValues, TName>) => {
	const ChildComponent = isMobile ? 'option' : MenuItem;

	return (
		<ControlledTextField
			select
			slotProps={{
				select: {
					native: isMobile,
				},
			}}
			{...rest}>
			{isMobile && <option />}
			{options.map(({ id, label, icon, endIcon }: OptionWithIcon) => (
				<ChildComponent id={id} key={id} value={id}>
					{isSelectedIconOnly || isMobile || (!icon && !endIcon) ? (
						<SelectLabel label={label} />
					) : (
						<SelectIconLabel
							icon={icon}
							label={label}
							endIcon={endIcon}
						/>
					)}
				</ChildComponent>
			))}
			{children}
		</ControlledTextField>
	);
};
